<script setup lang="ts">
import { computed, ref } from 'vue';
import { CompromissoForm } from '~/lib/fw';
import { useAuthenticationStore } from '~/stores/authenticationStore';

interface Props {
  compromisso?: any;
  fluxo?: any;
}

const props = defineProps<Props>();

const emit = defineEmits(['close']);

const planilhaRef = ref<any>(null);

const authenticationStore = useAuthenticationStore();
const buttonsDisabled = computed(() => {
  if (!props.compromisso) {
    return false;
  }
  return authenticationStore.user!.id !== props.compromisso.responsavelCodigo;
});

async function preSubmit(model: any) {
  console.log(model);
  if (model.solicitarEnvioPlanilhaNovamente.value === false) {
    await planilhaRef.value.upload();
  }

  return model;
}
</script>

<template>
  <CompromissoForm
    action="planilha-atualizacao-debito/enviar-planilha-atualizada"
    :compromisso-codigos="props.compromisso ? [props.compromisso.codigo] : []"
    :wait-for-result="true"
    :show-upload-files="false"
    :pre-submit="preSubmit"
    :submit-button-disabled="buttonsDisabled"
    @close="() => emit('close')"
  >
    <template #form="{ model }">
      <a-form-item
        label="Escolha uma opção"
        name="solicitarEnvioPlanilhaNovamente"
        :rules="[
          {
            message: 'Selecione uma das opções',
            required: true,
            type: 'boolean',
          },
        ]"
      >
        <a-radio-group
          v-model:value="model.solicitarEnvioPlanilhaNovamente"
          button-style="solid"
        >
          <a-radio-button :value="true"
            >Solicitar novamente o envio dos dados de atualização de
            débito</a-radio-button
          >
          <a-radio-button :value="false"
            >Enviar planilha de atualização de débito atualizada</a-radio-button
          >
        </a-radio-group>
      </a-form-item>

      <a-form-item
        v-if="model.solicitarEnvioPlanilhaNovamente === false"
        label="Planilha"
        name="planilha"
        :rules="{
          message: 'Planilha é obrigatória',
          required: true,
          trigger: 'change',
          type: 'object',
        }"
      >
        <UploadFile ref="planilhaRef" v-model:file="model.planilha" />
      </a-form-item>

      <a-form-item label="Observação" name="observacao">
        <a-textarea v-model:value="model.observacao" :rows="4" />
      </a-form-item>
    </template>
  </CompromissoForm>
</template>
